<!--  -->
<template>
  <van-dialog
    v-model="captchaOpen"
    title="请输入图中计算结果"
    show-cancel-button
    @confirm="submitCaptcha"
  >
    <div class="captchaDiv">
      <img
        :src="captchaSrc"
        @click="refreshCaptcha"
      >
      <el-input
        v-model="captchaVal"
        placeholder=""
        style="width:80px;height: 60px;margin-left: 10px"
      />
    </div>
  </van-dialog>
</template>

<script>
import { captchaImage } from '@/api/login'

export default {
  name: 'Captcha',
  components: {},
  data () {
    return {
      captchaOpen: false,
      captchaSrc: '',
      captchaVal: '',
      uuid: ''
    }
  },
  computed: {},
  created () {

  },
  mounted () {

  },
  methods: {
    refreshCaptcha () {
      captchaImage().then((res) => {
        this.captchaSrc = 'data:image/png;base64,' + res.img
        this.uuid = res.uuid
      })
    },
    openCaptcha () {
      this.captchaOpen = true
      captchaImage().then((res) => {
        this.captchaSrc = 'data:image/png;base64,' + res.img
        this.uuid = res.uuid
      })
    },
    submitCaptcha () {
      if (this.captchaVal) {
        const param = {
          captchaVal: this.captchaVal,
          uuid: this.uuid
        }
        this.captchaVal = ''
        this.uuid = ''
        this.captchaOpen = false
        this.$emit('submitCa', param)
      } else {
        this.$message.error('请输入验证码')
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.captchaDiv {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100px;
}
/deep/ .el-input__inner{
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/captacha.vue